import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FaFacebook, FaInstagram, FaTwitter, FaYoutube, FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';

const FooterContainer = styled.footer`
  background-color: ${({ theme }) => theme.colors.dark};
  color: ${({ theme }) => theme.colors.light};
  padding: ${({ theme }) => theme.spacing.xxl} 0;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 ${({ theme }) => theme.spacing.md};
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: ${({ theme }) => theme.spacing.xl};
  
  @media (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    grid-template-columns: 1fr;
  }
`;

const FooterSection = styled.div`
  h3 {
    color: ${({ theme }) => theme.colors.primaryDark};
    margin-bottom: ${({ theme }) => theme.spacing.lg};
    font-size: ${({ theme }) => theme.fontSizes.large};
    position: relative;
    
    &:after {
      content: '';
      position: absolute;
      bottom: -10px;
      left: 0;
      width: 50px;
      height: 2px;
      background-color: ${({ theme }) => theme.colors.primaryDark};
    }
  }
  
  p {
    margin-bottom: ${({ theme }) => theme.spacing.md};
  }
`;

const FooterLinks = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  
  li {
    margin-bottom: ${({ theme }) => theme.spacing.sm};
  }
  
  a {
    color: ${({ theme }) => theme.colors.light};
    transition: ${({ theme }) => theme.transitions.short};
    
    &:hover {
      color: ${({ theme }) => theme.colors.primaryDark};
      padding-left: ${({ theme }) => theme.spacing.sm};
    }
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.md};
  margin-top: ${({ theme }) => theme.spacing.md};
  
  a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: ${({ theme }) => theme.borderRadius.round};
    background-color: rgba(255, 255, 255, 0.1);
    color: ${({ theme }) => theme.colors.light};
    transition: ${({ theme }) => theme.transitions.short};
    
    &:hover {
      background-color: ${({ theme }) => theme.colors.primaryDark};
      color: ${({ theme }) => theme.colors.white};
      transform: translateY(-3px);
    }
  }
`;

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing.md};
  
  svg {
    margin-right: ${({ theme }) => theme.spacing.sm};
    color: ${({ theme }) => theme.colors.primary};
  }
`;

const BottomBar = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: ${({ theme }) => theme.spacing.lg} ${({ theme }) => theme.spacing.md} 0;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: ${({ theme }) => theme.spacing.xl};
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    flex-direction: column;
    text-align: center;
    gap: ${({ theme }) => theme.spacing.md};
  }
`;

const Copyright = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.small};
  margin: 0;
`;

const LegalLinks = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.md};
  
  a {
    color: ${({ theme }) => theme.colors.light};
    font-size: ${({ theme }) => theme.fontSizes.small};
    
    &:hover {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.sm};
  }
`;

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <h3>About Us</h3>
          <p>Simran Kaur Makeovers provides professional makeup and beauty services for all occasions. With years of experience and a passion for beauty, we make sure you look your absolute best.</p>
          <SocialLinks>
            <a href="https://www.facebook.com/simrankaurmakeoverspage" target="_blank" rel="noopener noreferrer"><FaFacebook /></a>
            <a href="https://www.instagram.com/simrankaurmakeovers_" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
          </SocialLinks>
        </FooterSection>
        
        <FooterSection>
          <h3>Quick Links</h3>
          <FooterLinks>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/portfolio">Portfolio</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </FooterLinks>
        </FooterSection>
        
        <FooterSection>
          <h3>Services</h3>
          <FooterLinks>
            <li><Link to="/portfolio">Bridal Makeup</Link></li>
            <li><Link to="/portfolio">Party Makeup</Link></li>
            <li><Link to="/portfolio">Fashion Makeup</Link></li>
            <li><Link to="/portfolio">Pre-Wedding Makeup</Link></li>
            <li><Link to="/portfolio">Special Occasion Makeup</Link></li>
          </FooterLinks>
        </FooterSection>
        
        <FooterSection>
          <h3>Contact Info</h3>
          <ContactItem>
            <FaMapMarkerAlt />
            <span>B-368, 1st Floor, Meera Bagh B Block, Paschim Vihar, New Delhi, 110063</span>
          </ContactItem>
          <ContactItem>
            <FaPhone />
            <span>+91 8360931465</span>
          </ContactItem>
          <ContactItem>
            <FaEnvelope />
            <span>skmakeovers24@gmail.com</span>
          </ContactItem>
        </FooterSection>
      </FooterContent>
      
      <BottomBar>
        <Copyright>© {currentYear} Simran Kaur Makeovers. All Rights Reserved.</Copyright>
        <LegalLinks>
          <Link to="/terms">Terms & Conditions</Link>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/refund">Refund Policy</Link>
        </LegalLinks>
      </BottomBar>
    </FooterContainer>
  );
};

export default Footer;
